import { doDELETE, doGET, doPOST, doPUT } from "../util/HttpUtil";
import { REVIEW_TASK_KIND, REVIEW_TASK_STATUS } from "../constants/reviewConstants";

export const buildEmptyFormReview = (applicationId = "") => ({
  application_id: applicationId,
  tasks: [],
});

const normalizeTaskKind = (kind) => {
  if (kind === REVIEW_TASK_KIND.FIELD_CLARIFICATION || kind === "FIELD_CLARIFICATION") {
    return REVIEW_TASK_KIND.FIELD_CLARIFICATION;
  }
  if (kind === REVIEW_TASK_KIND.EXTRA_QUESTION || kind === "EXTRA_QUESTION") {
    return REVIEW_TASK_KIND.EXTRA_QUESTION;
  }
  if (kind === REVIEW_TASK_KIND.DOCUMENT_REQUEST || kind === "DOCUMENT_REQUEST") {
    return REVIEW_TASK_KIND.DOCUMENT_REQUEST;
  }

  const parsed = Number(kind);
  return Number.isFinite(parsed) ? parsed : REVIEW_TASK_KIND.FIELD_CLARIFICATION;
};

const normalizeTaskStatus = (task = {}) => {
  const rawStatus = task?.status ?? task?.refill;
  const parsed = Number(rawStatus);
  if (parsed === REVIEW_TASK_STATUS.AWAITING_REVIEW
    || parsed === REVIEW_TASK_STATUS.COMPLETED
    || parsed === REVIEW_TASK_STATUS.ACTIONABLE) {
    return parsed;
  }
  return REVIEW_TASK_STATUS.ACTIONABLE;
};

const normalizeTask = (task = {}) => ({
  ...(task || {}),
  kind: normalizeTaskKind(task?.kind),
  status: normalizeTaskStatus(task),
});

export const isPersistableFormReviewTask = (task = {}) => (
  normalizeTaskKind(task?.kind) === REVIEW_TASK_KIND.FIELD_CLARIFICATION
);

export const filterPersistableFormReviewTasks = (tasks = []) => (
  (Array.isArray(tasks) ? tasks : [])
    .map(normalizeTask)
    .filter((task) => isPersistableFormReviewTask(task))
);

const normalizeFormReview = (data, applicationId = "") => ({
  ...buildEmptyFormReview(applicationId),
  ...(data || {}),
  application_id: data?.application_id || applicationId,
  tasks: filterPersistableFormReviewTasks(data?.tasks),
});

export const getFormReviewDetail = async (applicationId) => {
  if (!applicationId) {
    return buildEmptyFormReview();
  }
  const response = await doGET(`/api/form-review/detail?application_id=${encodeURIComponent(applicationId)}`);
  return normalizeFormReview(response?.data, applicationId);
};

export const saveFormReview = async (payload) => {
  const normalizedPayload = normalizeFormReview(payload, payload?.application_id);
  const response = payload?._id
    ? await doPUT("/api/form-review/update", normalizedPayload)
    : await doPOST("/api/form-review/create", normalizedPayload);
  return normalizeFormReview(response?.data, payload?.application_id);
};

export const deleteFormReview = async (applicationId) => {
  if (!applicationId) {
    return null;
  }
  return doDELETE(`/api/form-review/delete?application_id=${encodeURIComponent(applicationId)}`);
};
